import { Object3D, ArrowHelper, Vector3 } from 'three';
import * as CANNON from 'cannon-es';

export default class Ball {
    constructor(mesh, GAME) {

        this.mesh = mesh;
        this.object = new Object3D();
        this.GAME = GAME;

        this.init();
    }

    init() {

        this.mesh.scene.traverse((child) => {
            if (child.isMesh && child.material.map) {
                child.material.map.anisotropy = this.GAME.renderer.capabilities.getMaxAnisotropy();
                child.material.needsUpdate = true;
                if (this.GAME.config.shadows) {
                    child.castShadow = true;
                    child.receiveShadow = true;
                } else {
                    child.castShadow = false;
                    child.receiveShadow = false;
                }
            }
        });

        this.ballMesh = this.mesh.scene;
        this.ballMesh.position.set(0, 0, this.GAME.config.ball.height * .86);
        this.ballMesh.rotation.set(Math.PI / -2, 0, 0);

        this.object.add(this.ballMesh);

        this.initPhysics()

    }

    initPhysics() {

        this.body = new CANNON.Body({
            mass: 0,
            type: CANNON.Body.STATIC,
            position: new CANNON.Vec3(0, .5, 0),
            shape: new CANNON.Cylinder(this.GAME.config.ball.diameter / 2, this.GAME.config.ball.diameter / 2, this.GAME.config.ball.height, 40),
            material: this.GAME.ballMaterial
        });

        this.body.addShape(new CANNON.Sphere(this.GAME.config.ball.diameter / 2), new CANNON.Vec3(0, this.GAME.config.ball.height / 2, 0));
        this.body.addShape(new CANNON.Sphere(this.GAME.config.ball.diameter / 2), new CANNON.Vec3(0, -this.GAME.config.ball.height / 2, 0));

        this.body.restitution = this.GAME.config.ball.restitution;

        this.body.angularDamping = this.GAME.config.ball.angular_damping;


    }


}